import z, { type ZodType } from 'zod'

import { TeamDomainSelectModelFiltersSchema } from '@mntn-dev/domain-types'
import type { TeamDomainQueryModelRelations } from '@mntn-dev/repository'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const QueryTeamsInputSchema = z
  .object({
    include: z.custom<TeamDomainQueryModelRelations>(),
    where: TeamDomainSelectModelFiltersSchema,
    schema: z.custom<ZodType>(),
  })
  .partial()

export type QueryTeamsInput<TSchema extends ZodType = ZodType> = Omit<
  ZodInfer<typeof QueryTeamsInputSchema>,
  'schema'
> & {
  schema?: TSchema
}
